import { axiosReq } from "../../../../common/utils/axios";

export const tryPostReferral = (email) => {
    return async dispatch => {
        return axiosReq(`apiv1/coach/referrals`, 'POST', { "email": email }, {});
    }
};